import { render, staticRenderFns } from "./RichPopover.vue?vue&type=template&id=61f5f81e&scoped=true"
import script from "./RichPopover.vue?vue&type=script&lang=js"
export * from "./RichPopover.vue?vue&type=script&lang=js"
import style0 from "./RichPopover.vue?vue&type=style&index=0&id=61f5f81e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5f81e",
  null
  
)

export default component.exports